import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 2,
  },
});

class PageTitle extends PureComponent {
  render() {
    const { classes, children } = this.props;

    return (
      <Typography
        className={classes.container}
        variant="display1"
      >
        { children }
      </Typography>
    );
  }
}

export default withStyles(styles)(PageTitle);

PageTitle.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ]).isRequired,
};



// WEBPACK FOOTER //
// ./src/components/PageTitle.js